





























































import QuoteFreightTemplateList from '@/components/quotes/templates/freights/QuoteFreightTemplateList.vue';
import QuoteFreightTemplateFormDialog from '@/components/quotes/templates/freights/QuoteFreightTemplateFormDialog.vue';

import Vue from 'vue';
import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';
import { IQuoteFreightTemplate, QuoteFreightTemplate } from '@/models';
import ALPage from '@/components/core/Page/ALPage.vue';

export default Vue.extend({
  components: {
    QuoteFreightTemplateList,
    QuoteFreightTemplateFormDialog,
    ALPage
  },

  data: () => ({
    search: '',

    errorMessage: '',
    detailErrorMessage: ''
  }),

  methods: {
    ...mapActions({
      deleteQuoteFreightTemplate: 'quoteTemplate/deleteQuoteFreightTemplate'
    }),

    openFreight(item?: IQuoteFreightTemplate, createForm = true) {
      const dialog = (this as any).$refs.quoteFreightFormDialog;
      dialog.open(item ?? new QuoteFreightTemplate(), createForm);
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async deleteQuoteFreightItem(item: IQuoteFreightTemplate) {
      const confirm = (this as any).$refs.confirm;
      const title = item.title;

      if (
        await confirm.open(
          'Delete Quote Freight',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <div><strong class="text--primary" style="word-break: normal">${title}</strong>?</div> <br /> This action cannot be undone.</span>`
        )
      ) {
        this.clearAllErrors();
        await this.deleteQuoteFreightTemplate(item.id).catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        });
      }
    }
  }
});
